import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from './../../auth/services/login.service';
import { CommonService } from '../services';
import { EEntityTypes } from '../enums';
import { IPreferences } from '../panels/chart/Models/chart-settings.model';

// import jwt_decode from "jwt-decode";

@Injectable()
export class RestInterceptor implements HttpInterceptor {
  readonly dateProperties: string[] = ['lastTagUpdatedTime', 'createdOn', 'updatedOn', 'created_date', 'updated_date', 't', 'timestamp', 'startDate', 'endDate', 'last_trigger_time'];

  constructor(private loginService: LoginService, private router: Router, private toastr: ToastrService, private readonly commonService: CommonService) { }

  get isUserDashboardPage() { return this.router.url.includes(EEntityTypes.User_Dashboard) }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = JSON.parse(localStorage.getItem('Token'))?.accessToken || '';

    // console.log('jwt_decode :>> ', jwt_decode(token));
    if (token) {
      request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
    }

    if (!request.headers.has('Content-Type')) {
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    } else if (request.headers.get('Content-Type').length === 0) {
      // FormData file upload content type not needed
      request = request.clone({ headers: request.headers.delete('Content-Type') });
    }
    if (!request.body || request.body['type'] !== 'refresh-token') {
      this.loginService.setApiTriggerTime(new Date().getTime());
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any> | any) => {
        console.log('Response: ', event);
        const preferences: IPreferences = this.commonService._preferences.getValue();
        if (event.body?.data) {
            // /agg-data and /live-data
            if (event.body.data.configs?.length && this.isUserDashboardPage) {
              event.body.data.configs.forEach(config => config.t = new DatePipe('en-Us').transform(this.commonService.setTimeAsPerTimezone(new Date(config.t), preferences.timezone.offset), 'dd/M/yyyy hh:mm:ss a'));
            } else if (event.body.data.tags?.length && this.isUserDashboardPage) {
              // /live-data
              event.body.data.tags.forEach(tag => {
                if (tag.name === 'Offline TimeDate' || tag.name === 'Online TimeDate') {
                  const tagValue: number = new Date(tag.v).getTime();
                  const updatedTagValue = this.commonService.setTimeAsPerTimezone(new Date(tagValue), preferences.timezone.offset);
                  tag.v = updatedTagValue ? new DatePipe('en-Us').transform(new Date(updatedTagValue), 'dd/M/yyyy hh:mm:ss a') : '';
                }

                if (tag.t && typeof (tag.t) === 'string') {
                  const tagTime: number = new Date(tag.t).getTime();
                  tag.tempTimestamp = new Date(this.commonService.setTimeAsPerTimezone(new Date(tagTime), preferences.timezone.offset));
                  tag.t = new DatePipe('en-Us').transform(new Date(this.commonService.setTimeAsPerTimezone(new Date(tagTime), preferences.timezone.offset)), 'dd/M/yyyy hh:mm:ss a');
                } else if(tag.t && typeof (tag.t) !== 'string') {
                  tag.tempTimestamp = new Date(this.commonService.setTimeAsPerTimezone(new Date(tag.t), preferences.timezone.offset));
                  tag.t = new DatePipe('en-Us').transform(new Date(this.commonService.setTimeAsPerTimezone(new Date(tag.t), preferences.timezone.offset)), 'dd/M/yyyy hh:mm:ss a');
                }
              });
            } else {
              // for rest GQL and API calls
            if (Array.isArray(event.body)) {
              // handle arrays
              return new HttpResponse({ ...event, body: event.body.map((item) => this.setDatesAsPerZone(item)) });
            } else {
              // handle objects
              return new HttpResponse({ ...event, body: this.setDatesAsPerZone(event.body) });
            }
          }
        }

        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        const data = {
          reason: error && error.error && error.error.reason ? error.error.reason : '',
          status: error.status
        };
        if (data.status === 0) {
          this.toastr.error('An error connecting to the internet has occured. Check your network connection and try again.', 'Connection error', {
            timeOut: 3000,
            positionClass: 'toast-top-right'
          });
        }
        if (error.status === 400 && this.isUserDashboardPage && request.url.includes('live-data')) {
          console.log('live-data API CAll Failed (status 400)');
        } else if (typeof error.error === 'string' && error.error === 'Validation Failed') {
          this.loginService.logOut(true);
        } else if (error.status >= 500) {
          this.toastr.error('Something bad has happened on our servers. We\'ll try to fix it as soon as possible', 'An error occured', {
            timeOut: 3000,
            positionClass: 'toast-top-right'
          });
        } else {

        }
        return throwError(error);
      }));
  }

  /**
   * set dates as per selected timezone
   * @param dataItem data
   */
  private setDatesAsPerZone(dataItem: any): any {
    const preferences: IPreferences = this.commonService._preferences.getValue();
    if (dataItem) {
      if (typeof dataItem === 'object') {
        // If dataItem is an object, iterate through its properties
        for (const key in dataItem) {
          if (dataItem.hasOwnProperty(key)) {
            if (Array.isArray(dataItem[key])) {
              // If the property is an array, recursively check its elements
              dataItem[key] = dataItem[key].map((item) => this.setDatesAsPerZone(item));
            } else if (typeof dataItem[key] === 'object') {
              // If the property is another object, recursively check its properties
              dataItem[key] = this.setDatesAsPerZone(dataItem[key]);
            } else if (this.dateProperties.includes(key)) {
              // If the property is 'startDate', modify it
              dataItem[key] = this.commonService.setTimeAsPerTimezone(new Date(dataItem[key]), preferences.timezone.offset);; // Example modification
            }
          }
        }
      }
    }

    return dataItem;
  }

}